import React, { useEffect, useState } from 'react';
import { useAuth } from 'contexts/AuthProvider';
import { useCart } from 'contexts/CartProvider';
import CartIcon from './CartIcon';

function CartBar() {
    const { authenticating, isAuthenticated } = useAuth();
    const { getCartCount, cart } = useCart();
    const [count, setCount] = useState(0);

    useEffect(() => {
        setCount(getCartCount());
    }, [authenticating, cart]);

    return (<>
        <a href={void (0)}>
            <CartIcon width={22} height={22}></CartIcon>
            <span className='ms-1'>({count})</span>
        </a>
    </>);
}

export default CartBar;